import { HorizontalBar, mixins } from 'vue-chartjs';
import chartMixin from './chartMixin';
export default {
  name: 'NiotaClassicChartsHorizontalBar',
  extends: HorizontalBar,
  mixins: [mixins.reactiveProp, chartMixin],
  props: {
    chartData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    multiChartData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    multiChartData: {
      handler: function handler() {
        this.updateBarChart();
      },
      deep: true
    },
    chartData: {
      handler: function handler() {
        this.updateBarChart();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.updateBarChart();
  },
  methods: {
    updateBarChart: function updateBarChart() {
      var mappedChartData = this.mapChartData();
      var chartOptions = this.chartOptions(this.options);
      this.renderChart({
        labels: mappedChartData.labels,
        datasets: mappedChartData.datasets
      }, chartOptions);
    },
    mapChartData: function mapChartData() {
      var _this = this;

      if (this.multiChartData.individual) {
        return {
          datasets: this.multiChartData.individual.map(function (dataset, index) {
            var color = _this.multiChartData.common.color ? _this.shadeColor(10 - index * 30, _this.multiChartData.common.color || '#17bc00') : dataset.color;
            return {
              label: dataset.label,
              pointBackgroundColor: color,
              borderColor: color,
              backgroundColor: color || 'transparent',
              pointRadius: 1,
              borderWidth: 2,
              data: dataset.data
            };
          }),
          labels: this.multiChartData.common.labels
        };
      } else {
        var color = this.shadeColor(10, this.chartData.color || '#17bc00');
        return {
          labels: this.chartData.dataLabels,
          datasets: [{
            label: this.chartData.label,
            pointBackgroundColor: color,
            borderColor: color,
            backgroundColor: color || 'transparent',
            pointRadius: 1,
            borderWidth: 2,
            data: this.chartData.data
          }]
        };
      }
    }
  }
};